import { FC } from 'react';

import { purpurBreakpointLg, purpurBreakpointMd, purpurBreakpointSm } from '@purpur/library/tokens';

import { BannerContainer, BannerImage } from './Banner.styles';

type BannerProps = {
    banner: {
        url?: string;
        images: {
            extra_small: string;
            mobile: string;
            tablet: string;
            desktop: string;
        };
        alt: string;
    };
};

type Props = {
    banner: BannerProps['banner'];
};

const BannerContent: FC<Props> = ({ banner }) => (
    <BannerContainer>
        <source media={`(max-width: ${purpurBreakpointSm})`} srcSet={banner.images.extra_small} />
        <source media={`(max-width: ${purpurBreakpointMd})`} srcSet={banner.images.mobile} />
        <source media={`(max-width: ${purpurBreakpointLg})`} srcSet={banner.images.tablet} />
        <BannerImage
            src={banner.images.desktop}
            alt={banner.alt}
            width={1920}
            height={400}
            priority={true}
            unoptimized={true}
        />
    </BannerContainer>
);

export const Banner: FC<BannerProps> = ({ banner }) => {
    if (!banner) {
        return null;
    }

    return banner.url ? (
        <a href={banner.url}>
            <BannerContent banner={banner} />
        </a>
    ) : (
        <BannerContent banner={banner} />
    );
};
